module.exports = __webpack_public_path__ + "img/icon-white.438dc11a.svg";